import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataUpdateStatus } from '../../types';

interface DataUpdateState {
  status: DataUpdateStatus;
  loading: boolean;
  error: string | null;
}

const initialState: DataUpdateState = {
  status: {
    status: 'idle',
    current_stock: '',
    processed_count: 0,
    total_stocks: 0,
    successful_count: 0,
    failed_count: 0,
    message: 'Data update not running',
    errors: [],
    completion_summary: '',
    last_completed: null,
    show_notification: false,
  },
  loading: false,
  error: null,
};

const dataUpdateSlice = createSlice({
  name: 'dataUpdate',
  initialState,
  reducers: {
    setDataUpdateStatus: (state, action: PayloadAction<DataUpdateStatus>) => {
      state.status = action.payload;
    },
    setDataUpdateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setDataUpdateError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setDataUpdateStatus,
  setDataUpdateLoading,
  setDataUpdateError,
} = dataUpdateSlice.actions;

export default dataUpdateSlice.reducer;

